import { ScoComponentDto } from "generated/CoreApi_v1";
import { useNavigate } from "react-router";
import { LmsPaths } from "routes/LmsRouter";
import { ScormPlayerService } from "services/scormPlayerService";
import { SessionService } from "services/sessionService";
import { NIL } from "uuid";
import { useEnrollmentViewContext } from "..";
import { TrainingRegistrationDialog } from "../../Registration/TrainingRegistrationDialog";

/////////////////////////////////////////////////////////////////////////////////////

export const getEnrollmentCertificate = (fileId: string) => {
    window.open(`${SessionService.current.apiPaths.coreApi}/Download/${fileId}`);
};

/////////////////////////////////////////////////////////////////////////////////////

export async function launchSco(enrollmentId: string, sco: ScoComponentDto, onClose?: () => void, readOnly?: boolean) {
    const popup = enrollmentId == NIL
        ? await ScormPlayerService.openCdsPlayerDemo(sco.scoId, sco.windowOption, sco.windowWidth, sco.windowHeight)
        : readOnly === true
            ? await ScormPlayerService.openCdsPlayerReview(enrollmentId, sco)
            : await ScormPlayerService.openCdsPlayer(enrollmentId, sco);

    if (popup != null) {
        popup.window.addEventListener('load',
            () => {
                popup.window.addEventListener('unload',
                    () => {
                        onClose && onClose();
                    });
            });
    }
}

/////////////////////////////////////////////////////////////////////////////////////

interface ReEnrollProps {
    onClose: () => void;
}

export const ReEnrollAction = ({ onClose }: ReEnrollProps) => {
    const navigate = useNavigate();
    const { enrollment } = useEnrollmentViewContext();

    return (
        <TrainingRegistrationDialog
            trainingId={enrollment.trainingId}
            masterEnrollmentId={enrollment.masterEnrollmentId ?? undefined}
            onClose={(result) => {
                if (result?.enrollmentId) {
                    navigate(LmsPaths.BuildEnrollmentViewer(enrollment.trainingType, result?.enrollmentId));
                }
                onClose();
            }}
        />
    );
};
